// Dashboard Categories - Shared between Dashboard and All Categories pages
import restaurant from "../assets/img/restaurant.png";
import hotel from "../assets/img/hotel.png";
import beauty from "../assets/img/beauty.png";
import homedecor from "../assets/img/homedecor.png";
import wedding from "../assets/img/wedding.png";
import education from "../assets/img/education.png";
import rent from "../assets/img/rent.png";
import hospital from "../assets/img/hospital.png";
import contractors from "../assets/img/contractors.png";
import pet from "../assets/img/pet.png";
import pg from "../assets/img/pg.png";
import dentist from "../assets/img/dentist.png";
import gym from "../assets/img/gym.png";
import event from "../assets/img/event.png";
import astrology from "../assets/img/icons/astrology.png";
import ac from "../assets/img/icons/ac-service.png";
import repair from "../assets/img/icons/repair.png";
import saree from "../assets/img/icons/saree.png";
import driving from "../assets/img/driving.png";
import packers from "../assets/img/packers.png";
import courier from "../assets/img/courier.png";
import popular from "../assets/img/popular.png";

export const DASHBOARD_CATEGORIES = [
  {
    name: "Restaurants",
    icon: restaurant,
    url: "/category/restaurants",
    slug: "restaurants",
    enabled: true,
  },
  {
    name: "Hotels",
    icon: hotel,
    url: "/category/hotels",
    slug: "hotels",
    enabled: true,
  },
  {
    name: "Beauty Spa",
    icon: beauty,
    url: "/category/beauty-spa",
    slug: "beauty-spa",
    enabled: true,
  },
  {
    name: "Home Decor",
    icon: homedecor,
    url: "/category/home-decor",
    slug: "home-decor",
    enabled: true,
  },
  {
    name: "Wedding Planning",
    icon: wedding,
    url: "/category/wedding-planning",
    slug: "wedding-planning",
    enabled: true,
  },
  {
    name: "Education",
    icon: education,
    url: "/category/education",
    slug: "education",
    enabled: true,
  },
  {
    name: "Rent & Hire",
    icon: rent,
    url: "/category/rent-hire",
    slug: "rent-hire",
    enabled: true,
  },
  {
    name: "Hospitals",
    icon: hospital,
    url: "/category/hospitals",
    slug: "hospitals",
    enabled: true,
  },
  {
    name: "Contractors",
    icon: contractors,
    url: "/category/contractors",
    slug: "contractors",
    enabled: true,
  },
  {
    name: "Pet Shops",
    icon: pet,
    url: "/category/pet-shops",
    slug: "pet-shops",
    enabled: true,
  },
  {
    name: "PG/Hostels",
    icon: pg,
    url: "/category/pg-hostels",
    slug: "pg-hostels",
    enabled: true,
  },
  {
    name: "Dentists",
    icon: dentist,
    url: "/category/dentists",
    slug: "dentists",
    enabled: true,
  },
  {
    name: "Gym",
    icon: gym,
    url: "/category/gym",
    slug: "gym",
    enabled: true,
  },
  {
    name: "Event Organisers",
    icon: event,
    url: "/category/event-organisers",
    slug: "event-organisers",
    enabled: true,
  },
  {
    name: "Astrology",
    icon: astrology,
    url: "/category/Astrology",
    slug: "Astrology",
    enabled: true,
  },
  {
    name: "Ac services",
    icon: ac,
    url: "/category/ac-service",
    slug: "ac-service",
    enabled: true,
  },
  {
    name: "repair services",
    icon: repair,
    url: "/category/repair-services",
    slug: "repair-services",
    enabled: true,
  },
  {
    name: "Saree",
    icon: saree,
    url: "/category/saree",
    slug: "saree",
    enabled: true,
  },
  {
    name: "Driving Schools",
    icon: driving,
    url: "/category/driving-schools",
    slug: "driving-schools",
    enabled: true,
  },
  {
    name: "Packers & Movers",
    icon: packers,
    url: "/category/packers-movers",
    slug: "packers-movers",
    enabled: true,
  },
  {
    name: "Courier Service",
    icon: courier,
    url: "/category/courier-service",
    slug: "courier-service",
    enabled: true,
  },
  {
    name: "Popular Categories",
    icon: popular,
    url: "/category/popular",
    slug: "popular",
    enabled: true,
  },
];
